// extracted by css-extract-rspack-plugin
export default {"ssoWarningBanner":"WarningBanner-module__ssoWarningBanner__bncWG","alertIcon":"WarningBanner-module__alertIcon__oQBZ4","ssoSignInLink":"WarningBanner-module__ssoSignInLink__DOjWy"};